import {emotionStyled} from '@packages/utilities/styled';
import {Card} from '../Card';
import {tokens} from '../../themes';
import {Text} from '../Text';
import {hoverSelector} from '../../utils';

export const RadioWrapperView = emotionStyled('div')(
  {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  {
    componentName: 'RadioCardWrapper',
    variants: {
      isAbsolutelyPositioned: {
        true: {
          position: 'absolute',
          top: '$3',
          right: '$3',
        },
      },
    },
  }
);

export const RadioInputView = emotionStyled('input')(
  {
    appearance: 'none',
    bottom: 0,
    left: 0,
    margin: 0,
    opacity: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  {
    componentName: 'RadioCardInput',
  }
);

const OUTLINE_COLOR = '--radio-card-outline-color';
const BORDER_HIGHLIGHT_COLOR = '--radio-card-border-highlight-color';

export const RadioCardView = emotionStyled(Card)(
  {
    border: '$border1',
    borderRadius: '$2',
    outlineOffset: 2,
    [`&:has(${RadioInputView}:focus:not(:focus-visible))`]: {
      outline: 'none',
    },
    [`&:has(${RadioInputView}:focus-visible)`]: {
      outlineColor: `var(${OUTLINE_COLOR})`,
      outlineStyle: 'solid',
      outlineWidth: 1,
    },
  },
  {
    componentName: 'RadioCard',
    variants: {
      colorVariant: {
        blue: {
          [OUTLINE_COLOR]: tokens.colors.blueBorder,
          [BORDER_HIGHLIGHT_COLOR]: tokens.colors.blueBorder,
        },
        purple: {
          [OUTLINE_COLOR]: tokens.colors.purpleBorder,
          [BORDER_HIGHLIGHT_COLOR]: tokens.colors.purpleBorder,
        },
        green: {
          [OUTLINE_COLOR]: tokens.colors.greenBorder,
          [BORDER_HIGHLIGHT_COLOR]: tokens.colors.greenBorder,
        },
      },
      emphasizeBackground: {
        true: {
          [`&${hoverSelector}`]: {
            background: '$backgroundRaised',
          },
          '&:has(input[aria-checked="true"]), &:active': {
            background: '$backgroundRaised',
          },
        },
      },
      isDisabled: {
        /**
         * hardcoded for now to match figma opacity
         * @see https://webflow.slack.com/archives/C012XUU5EQL/p1699629018260439
         */
        true: {opacity: tokens.opacities.disabled},
      },
      isError: {
        true: {
          [OUTLINE_COLOR]: tokens.colors.redBorder,
          [BORDER_HIGHLIGHT_COLOR]: tokens.colors.redBorder,
        },
      },
      shouldHighlightSelected: {
        true: {
          [`&:has(${RadioInputView}:not([aria-disabled="true"]):checked)`]: {
            borderColor: `var(${BORDER_HIGHLIGHT_COLOR})`,
          },
        },
      },
    },
  }
);

export const LabelTextView = emotionStyled(Text)(
  {},
  {
    variants: {
      hasDescription: {
        true: {
          fontWeight: tokens.typography.fontWeight.semibold,
        },
      },
    },
  }
);
